export class ErrorResponse {
    errorCode: number;
    errors: ErrorKeyValuePair[];
    result?: any;
}

export class ResultKeyValuePair {
    Key: string;
    Value: string;
}

export class ErrorKeyValuePair {
    Key: string;
    Value: string;
}


export class AWSCognitoErrorResponse {
    code: string;
    message: string;
    name: string;
}

export class AWSS3ErrorResponse {
    code: string;
    message: string;
    name: string;
}
